import useCurrentUser from '../../api/queries/currentUser/useCurrentUser'
import {
  PERSON_TYPE_ADMIN,
  PERSON_TYPE_IT_MANAGER,
  PERSON_TYPE_MENTOR,
  PERSON_TYPE_STUDENT,
  PERSON_TYPE_TEACHER,
} from '../../constants'

const ROLE_LABEL = {
  [PERSON_TYPE_STUDENT]: 'Leerling',
  [PERSON_TYPE_TEACHER]: 'Leerkracht',
  [PERSON_TYPE_MENTOR]: 'Begeleider',
  [PERSON_TYPE_IT_MANAGER]: 'ICT Coördinator',
  [PERSON_TYPE_ADMIN]: 'Admin',
}

export const useUserProfileInformation = () => {
  const { data } = useCurrentUser()

  if (data) {
    return {
      avatarUri: data?.image_url,
      fullName: data?.full_name,
      firstName: data?.first_name,
      initials: data?.initials,
      role: data?.person_type && ROLE_LABEL[data.person_type],
    }
  }
}
